import { oz } from '@weft/utils';
import { SlackTextBlockSchema } from './slack-text-block';

export const SlackBlockSchema = oz.object({
  type: oz.string(),
  text: SlackTextBlockSchema.optional(),
  elements: oz.array(oz.object({ 
    type: oz.string(),
    text:  SlackTextBlockSchema.optional(),
    action_id: oz.string().optional(),
  })).optional(),
});

export type SlackBlock = oz.infer<typeof SlackBlockSchema>;